import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";
import { notifyError, notifySuccess } from "./notification.slice";
import { authFailCheck } from "./auth.slice";
import PromoService from "./../services/PromoService";
import { categorySelectors } from "redux/category.slice";

const promoAdapter = createEntityAdapter({
  selectId: (promo) => promo.id
});

const initialState = promoAdapter.getInitialState({
  isLoading: false,
  filter: {
    categoryId: 0,
    status: 0,
    keyword: "",
    sortBy: null,
    sortOrder: 1,
    pageNumber: 1,
    pageSize: 25,
  },
});
const promoSlice = createSlice({
  name: "promos",
  initialState: initialState,
  reducers: {
    fetchRequest(state, action) {
      state.isLoading = true;
      state.filter = { ...state.filter, ...action.payload };
    },
    fetchFail(state, action) {
      state.isLoading = false;
    },
    fetchPromosSuccess(state, action) {
      const { payload } = action;
      state.isLoading = false;
      state.pageCount = payload.pageCount;
      state.recordCount = payload.recordCount;
      state.filter = payload.filter;

      state.ids = [];
      state.entities = [];

      payload.items.forEach((item, index) => {
        state.ids[index] = item.id;
        state.entities[item.id] = item;
      });
    },
    createPromoSuccess(state, action) {
      state.isLoading = false;
      promoAdapter.addOne(state, action.payload);
    },
    updatePromoSuccess(state, action) {
      const { payload } = action;
      state.isLoading = false;
      promoAdapter.upsertOne(state, payload);
    },
    deletePromoSuccess(state, action) {
      state.isLoading = false;
      promoAdapter.removeOne(state, action.payload);
    },
  },
});

export default promoSlice.reducer;

export const {
  fetchRequest,
  fetchFail,
  fetchPromosSuccess,
  updatePromoSuccess,
  deletePromoSuccess,
  createPromoSuccess,
} = promoSlice.actions;

export const promoSelectors = promoAdapter.getSelectors(
  (state) => state.promos
);

export const fetchPromos = (filter) => async (dispatch) => {
  dispatch(fetchRequest(filter));

  const response = await PromoService.get(filter);
  if (response.ok) {
    dispatch(fetchPromosSuccess(response.data));
  } else {
    dispatch(authFailCheck(response));
    dispatch(fetchFail(response.data));
  }
};

export const createPromo = (promo) => async (dispatch, getState) => {
  dispatch(fetchRequest());

  const response = await PromoService.create(promo);

  if (response.ok) {
    const { id } = response.data;
    var category = categorySelectors.selectById(getState(), promo.categoryId);
    dispatch(createPromoSuccess({ id, categoryName: category.name, ...promo }));
    dispatch(notifySuccess(`${promo.name} aksiya yaratildi.`));
    dispatch(fetchPromos(initialState.filter));
  } else {
    dispatch(authFailCheck(response));
    dispatch(
      notifyError(`${promo.name} aksiya yaratishda xatolik.: ${response.data}`)
    );
    dispatch(fetchFail(response.data));
  }
};

export const updatePromo = (promoId, promo) => async (dispatch, getState) => {
  dispatch(fetchRequest());

  const response = await PromoService.update(promoId, promo);

  if (response.ok) {
    dispatch(notifySuccess(`${promo.name} o'zgartirildi.`));
    var category = categorySelectors.selectById(getState(), promo.categoryId);
    dispatch(
      updatePromoSuccess({ id: promoId, categoryName: category.name, ...promo })
    );
  } else {
    dispatch(authFailCheck(response));
    dispatch(
      notifyError(
        `${promo.name}ni o'zgartirishda xatolik: ${response.data.errors[0]}`
      )
    );
    dispatch(fetchFail(response.data));
  }
};

export const deletePromo = (promoId) => async (dispatch, getState) => {
  dispatch(fetchRequest());
  const promo = promoSelectors.selectById(getState(), promoId);
  const response = await PromoService.delete(promoId);
  if (response.ok) {
    dispatch(deletePromoSuccess(promoId));
    dispatch(notifySuccess(`${promo.name} o'chirildi.`));
  } else {
    dispatch(authFailCheck(response));
    dispatch(
      notifyError(`${promo.name}ni o'chirishda xatolik.: ${response.data}`)
    );
    dispatch(fetchFail(response.data));
  }
};
